import { useEffect, useRef, useState } from "react";

interface ObserverOptions {
  threshold?: number;
  rootMargin?: string;
  root?: Element | null;
}

export function useInView<T extends HTMLElement>(options?: ObserverOptions) {
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      options ?? { threshold: 0.12 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return { ref, inView };
}